import { CONSTANTS } from '../../constants/constants';
import { encodeParam } from '../../services/params.utils';
import EllipsisTypography from '../EllipsisTypography/EllipsisTypography';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import NRAssetRiskChanged from '../NRAssetRiskChanged/NRAssetRiskChanged';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { removeTabAndSubTabFromFilePath } from '../../services/urlInterceptor.utils';
import { StatusFormatter } from '../NRMisconfigurationTable/NRMisconfigurationTableCustomComponents/NRMisconfigurationStatusProvider/NRMisconfigurationStatusProvider';

const { BINARIES, CREDENTIALS, CRYPTOGRAPHY, FILE_SYSTEM, SBOM, VULNERABILITIES, MISCONFIGURATIONS } = CONSTANTS.REPORT.TABS;
const { EQUAL } = CONSTANTS.FILTER_OPERATIONS;

function NRActivityFeedItemHeader({ item, handleClose }) {
  const theme = useTheme();
  const { entity } = item;
  const location = useLocation();
  const activity = item?.activityType?.split('_').at(-1).toLowerCase();

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(handleTableRedirect(entity, entity.__typename));
    handleClose(); // close after navigation
  };

  const handleTableRedirect = (entity, typename) => {
    let redirectToBaseURL = removeTabAndSubTabFromFilePath(location);
    let extraParams = new URLSearchParams();
    let tab = '';
    switch (typename) {
      case 'VulnerabilityUpdatedPayload':
      case 'VulnerabilityRemovedPayload':
      case 'VulnerabilityRemediatedPayload':
        tab = VULNERABILITIES;
        extraParams.append(
          'vulnerabilityColumnFilter',
          encodeParam([
            {
              fieldName: 'CVE',
              value: entity.cve,
              operation: EQUAL
            }
          ])
        );
        break;
      case 'MisconfigChangedPayload':
        tab = MISCONFIGURATIONS;
        extraParams.append(
          'misconfigurationColumnsFilter',
          encodeParam([
            {
              fieldName: 'DISPLAYNAME',
              value: entity.checkName,
              operation: EQUAL
            }
          ])
        );
        break;
      case 'IdentificationRemovedPayload':
        tab = SBOM;
        extraParams.append(
          'componentColumnFilter',
          encodeParam(
            [
              {
                fieldName: 'NAME',
                value: entity.name,
                operation: CONSTANTS.FILTER_OPERATIONS.EQUAL.toUpperCase()
              },
              {
                fieldName: 'VENDOR',
                value: entity.vendor,
                operation: CONSTANTS.FILTER_OPERATIONS.EQUAL.toUpperCase()
              },
              {
                fieldName: 'VERSION',
                value: entity.version,
                operation: CONSTANTS.FILTER_OPERATIONS.EQUAL.toUpperCase()
              }
            ].filter(item => item.value) // removes falsy values like '', null, undefined
          )
        );
        break;
      default:
        break;
    }
    return `${redirectToBaseURL}${!!tab ? '/' + tab : ''}?${extraParams.toString()}`;
  };

  switch (entity.__typename) {
    case 'VulnerabilityRemediatedPayload':
    case 'VulnerabilityUpdatedPayload':
    case 'VulnerabilityAddedPayload':
    case 'VulnerabilityRemovedPayload':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EllipsisTypography
            onClick={() => handleClick()}
            variant="body2"
            sx={{ wordBreak: 'break-all', color: theme.palette.blue.link, cursor: 'pointer' }}
          >
            {entity.cve}
          </EllipsisTypography>
          <Typography sx={{ ml: 0.5, mr: 1 }} variant="body2" children={activity} />
        </Box>
      );
    case 'MisconfigChangedPayload':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EllipsisTypography
            onClick={() => handleClick()}
            variant="body2"
            sx={{ wordBreak: 'break-all', color: theme.palette.blue.link, cursor: 'pointer' }}
          >
            {entity.checkName}
          </EllipsisTypography>
          <Typography sx={{ ml: 0.5, mr: 1, whiteSpace: 'nowrap' }} variant="body2" children={` ${activity} to `} />
          <StatusFormatter value={entity?.newStatus} uppercase={entity?.newStatus?.toLowerCase() === 'na'} small={true} />
        </Box>
      );
    case 'IdentificationRemovedPayload':
    case 'IdentificationAddedPayload':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EllipsisTypography
            onClick={() => handleClick()}
            variant="body2"
            sx={{ wordBreak: 'break-all', color: theme.palette.blue.link, cursor: 'pointer' }}
          >
            {entity.name}
          </EllipsisTypography>
          <Typography sx={{ ml: 0.5, mr: 1, color: 'red' }} variant="body2" children={activity} />
        </Box>
      );
    case 'AssetRiskChangedPayload':
      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EllipsisTypography variant="body2" sx={{ wordBreak: 'break-all' }}>
            {entity?.name}
          </EllipsisTypography>
          <Typography sx={{ ml: 0.5, mr: 1 }} variant="body2" children={activity} />
          <NRAssetRiskChanged sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }} oldRisk={entity.oldRisk} newRisk={entity.newRisk} />
        </Box>
      );
    default:
      break;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', pb: 0.5 }}>
      <EllipsisTypography variant="body2" sx={{ wordBreak: 'break-all' }}>{`${
        entity?.name || entity?.componentName || entity?.userName || entity?.hash || entity?.checkId || entity?.groupId
      }`}</EllipsisTypography>
      <Typography sx={{ ml: 0.5, mr: 1 }} variant="body2" children={activity} />
    </Box>
  );
}
export default NRActivityFeedItemHeader;
